<template>
  <div>
    <page-header :title="$t('bill.cost_conversion_create')" />
    <page-body needMarginBottom>
      <a-row :gutter="10">
          <a-col :md="{ span: 24 }" :lg="{ span: 24 }" :xl="{ span: 22 }" :xxl="{ span: 20 }">
            <a-form-model
              ref="policyForm"
              class="mt-3"
              :model="form"
              :rules="rules"
              v-bind="formItemLayout">
              <a-form-model-item :label="$t('common.name')" prop="name">
                <a-input v-model="form.name" :placeholder="$t('validator.resourceName')" />
                <name-repeated
                  v-slot:extra
                  res="cost_conversions"
                  version="v1"
                  :name="form.name" />
              </a-form-model-item>
              <a-form-model-item :label="$t('bill.text_76')" prop="domain">
                <base-select
                  style="width: 600px;"
                  v-model="form.domain"
                  resource="domains"
                  version="v1"
                  remote
                  :mapper="(list) => { return [{ name: $t('common_723'), id: '' }, ...list] }"
                  :remote-fn="q => ({ filter: `name.contains(${q})` })"
                  :select-props="{ placeholder: `${$t('cloudenv.text_552')}，${$t('bill.cost_conversion_domain_helper')}`, allowClear: true }" />
              </a-form-model-item>
              <a-form-model-item :label="$t('bill.effective_start_time')" :extra="$t('bill.costconversion_time_tip')">
                <div class="d-flex">
                  <a-form-model-item prop="enable_date">
                    <a-month-picker
                      v-model="form.enable_date"
                      format="YYYY-MM"
                      :placeholder="$t('common.tips.select', [$t('bill.text_40')])" />
                  </a-form-model-item>
                  <!-- <div class="ml-2 mr-2">~</div>
                  <a-form-model-item prop="enable_date_end">
                    <a-month-picker
                      v-model="form.enable_date_end"
                      format="YYYY-MM"
                      :disabledDate="disabledEndDate"
                      :placeholder="$t('common.tips.select', [$t('bill.text_41')])" />
                  </a-form-model-item> -->
                </div>
              </a-form-model-item>
              <a-form-model-item :label="$t('bill.cost_conversion_env_brand')" prop="platform_brand">
                <a-row :gutter="24">
                  <a-col :span="6">
                    <base-select
                      v-model="form.cloud_env"
                      filterable
                      id-key="item_id"
                      name-key="item_name"
                      minWidth="160px"
                      :options="uniqueArr(options.cloud_envs)"
                      @change="v => change('cloud_env', v)"
                      :select-props="{ placeholder: $t('bill.text_49') }" />
                  </a-col>
                  <a-col :span="6">
                    <base-select
                      v-model="form.platform_brand"
                      filterable
                      id-key="item_id"
                      name-key="item_name"
                      minWidth="160px"
                      :options="uniqueArr(options.platform_brands)"
                      @change="v => change('platform_brand', v)"
                      :select-props="{ placeholder: $t('bill.text_49') }" />
                  </a-col>
                  <a-col :span="6" v-show="!isKvm">
                    <base-select
                      :selectProps="{labelInValue: true}"
                      v-model="form.account_id"
                      filterable
                      id-key="item_id"
                      name-key="item_name"
                      minWidth="160px"
                      @change="v => change('account_id', v)"
                      :options="options.accounts"
                      :select-props="{ placeholder: $t('bill.text_49') }" />
                  </a-col>
                  <a-col :span="6" v-show="!isKvm && !isAliyun">
                    <base-select
                      :selectProps="{labelInValue: true}"
                      v-model="form.cloudprovider_id"
                      filterable
                      id-key="item_id"
                      name-key="item_name"
                      minWidth="160px"
                      :options="options.cloudproviders"
                      :select-props="{ placeholder: $t('bill.text_49') }" />
                  </a-col>
                  <a-col :span="6" v-show="isAliyun">
                    <base-select
                      :selectProps="{labelInValue: true}"
                      v-model="form.owner_id"
                      filterable
                      id-key="item_id"
                      name-key="item_name"
                      minWidth="160px"
                      :options="options.owners"
                      :select-props="{ placeholder: $t('bill.text_49') }" />
                  </a-col>
                </a-row>
              </a-form-model-item>
              <a-form-model-item :label="$t('bill.policy_type')" prop="policy_type">
                <div class="d-flex align-items-center">
                  <a-radio-group v-model="form.policy_type">
                    <a-radio-button value="global">{{$t('bill.global_policy')}}</a-radio-button>
                    <a-radio-button v-if="isAliyun" value="resource">{{$t('bill.resource_policy')}}</a-radio-button>
                  </a-radio-group>
                  <template v-if="form.policy_type === 'resource'">
                    <a-button v-if="!isResrouceListShow" type="link" @click="()=>{changeResourceShow(true)}">{{$t('bill.has_resource_policy')}}</a-button>
                    <a-button v-if="!isResrouceListShow" type="link" @click="handleImportClick">{{$t('bill.import_policy_from_file')}}</a-button>
                    <base-select
                      class="ml-2"
                      v-if="isResrouceListShow"
                      v-model="form.policy_id"
                      resource="cost_conversions"
                      filterable
                      :params="{filter: 'type.equals(resource)'}"
                      :select-props="{ placeholder: $t('common.tips.select', [$t('bill.resource_policy')]), dropdownClassName: 'oc-select-dropdown' }"
                      @change="costConversionChange"
                      @update:resList="costConversionListChange">
                      <template #optionTemplate="{ options }">
                        <a-select-option v-for="item of options" :key="item.id" :value="item.id" :label="item.name">
                          <span class="text-color-secondary option-prefix mr-2">{{$t('bill.resource_policy')}}:</span>{{item.name}}
                        </a-select-option>
                      </template>
                    </base-select>
                    <a-button v-if="isResrouceListShow" type="link" @click="handleUseHasPolicyCancel">{{$t('common.cancel')}}</a-button>
                  </template>
                </div>
              </a-form-model-item>
              <a-form-model-item v-if="form.policy_type === 'global'" :label="$t('bill.cost_conversion_ratio')" prop="ratio">
                <a-input-number v-model="form.ratio" :min="0" :step="0.1" :precision="8" />
              </a-form-model-item>
              <template v-else>
                <a-form-model-item :label="$t('bill.resource_policy')" :rules="rules.policy_list" prop="policy_list">
                  <template v-for="(policy,index) in form.policy_list">
                    <a-row :key="index" :gutter="10" v-if="isProductShow(index)">
                      <a-col span="7" class="d-flex">
                        <div class="product-order">{{index + 1}}</div>
                        <a-form-model-item class="ml-2" style="flex: 1 1 auto;width:0" :rules="rules.policy_product" :prop="`policy_list.${index}.product_code`">
                          <base-select
                            :options="transProductOpts"
                            v-model="policy.product_code"
                            filterable
                            minWidth="100px"
                            :select-props="{ placeholder: $t('common.tips.select', [$t('bill.product_name')]), dropdownClassName: 'oc-select-dropdown' }"
                            :disabled-items="disabledProducts(index)"
                            :disabled="policy.product_code === 'others'"
                            :dropdown-item-word-wrap="true"
                            @change="val => productChange(val, index)">
                            <template #optionLabelTemplate="{ item }">
                              <span class="text-color-secondary option-prefix mr-2">{{$t('bill.product_name')}}:</span>{{item.name}}
                            </template>
                          </base-select>
                        </a-form-model-item>
                      </a-col>
                      <a-col span="8">
                        <a-form-model-item :rules="{ required: policy.product_code!=='others', message: $t('common.tips.select', [$t('bill.region')]) }" :prop="`policy_list.${index}.regions`">
                          <base-select
                            v-model="policy.regions"
                            filterable
                            :loading="regionLoading"
                            :options="regionOpts"
                            minWidth="100px"
                            :select-props="{ placeholder: $t('common.tips.select', [$t('bill.region')]), mode: 'multiple', dropdownClassName: 'oc-select-dropdown' }"
                            :disabled="policy.product_code==='others'"
                            :disabled-items="disabledRegions(policy.regions)">
                            <template #optionLabelTemplate="{ item }">
                              <span class="text-color-secondary option-prefix mr-2">{{$t('bill.region')}}:</span>{{item.name}}
                            </template>
                          </base-select>
                        </a-form-model-item>
                      </a-col>
                      <a-col span="4">
                        <a-form-model-item :rules="{ required: policy.product_code!=='others', message: $t('common.tips.select', [$t('bill.order_duration')]) }" :prop="`policy_list.${index}.duration`">
                          <base-select
                            :options="durationOpts"
                            v-model="policy.duration"
                            filterable
                            minWidth="100px"
                            isDefaultSelect
                            :select-props="{ placeholder: $t('common.tips.select', [$t('bill.order_duration')]), dropdownClassName: 'oc-select-dropdown' }"
                            :disabled="policy.product_code==='others'">
                            <template #optionLabelTemplate="{ item }">
                              <span class="text-color-secondary option-prefix mr-2">{{$t('bill.order_duration')}}:</span>{{item.name}}
                            </template>
                          </base-select>
                        </a-form-model-item>
                      </a-col>
                      <a-col span="5" class="d-flex align-items-center">
                        <a-form-model-item style="flex: 1 1 auto" class="mr-1" :rules="rules.policy_rate" :prop="`policy_list.${index}.rate`">
                          <a-input-number style="width:100%" v-model="policy.rate" :min="0" :step="0.1" :precision="8" :placeholder="$t('common.tips.input', [$t('bill.resource_ratio')])" />
                        </a-form-model-item>
                        <help-tooltip style="transform: translateY(-12px)" name="billCostConversionRateTip" />
                        <a-button v-if="policy.product_code !== 'others'" style="flex: 0 0 24px;margin-left:5px;transform:translateY(-12px)" shape="circle" icon="minus" size="small" @click="deletePolicy(policy,index)" />
                      </a-col>
                    </a-row>
                  </template>
                  <a-row v-if="isAddBtnShow">
                    <a-button type="primary" shape="circle" icon="plus" size="small" @click="addPolicy" />
                  </a-row>
                  <a-row class="d-flex align-items-center justify-content-end" v-if="form.policy_list.length !== 0">
                    <a-pagination
                      class="my-3 text-center"
                      showSizeChanger
                      :page-size="pager.pageSize"
                      :current="pager.current"
                      :total="form.policy_list.length"
                      :pageSizeOptions="['10', '20', '50', '100']"
                      @change="pageChange"
                      @showSizeChange="sizeChange"
                      :default-current="1">
                      <template #buildOptionText="props">
                        <span>{{ $t('bill.pager_size', [props.value]) }}</span>
                      </template>
                    </a-pagination>
                      <div class="vxe-pager--total" style="font-size: 12px;">{{ $t('common_717', [form.policy_list.length]) }}</div>
                  </a-row>
                </a-form-model-item>
              </template>
              <advance-config-block v-show="exchangeRateAvailable">
                  <a-form-model-item :label="$t('bill.application_bill')">
                    <base-select
                      style="width: 600px;"
                      v-model="form.currency_applied"
                      filterable
                      id-key="item_id"
                      name-key="item_name"
                      :options="currencyAppliedOpts"
                      :select-props="{ placeholder: $t('bill.text_49') }" />
                  </a-form-model-item>
              </advance-config-block>
            </a-form-model>
          </a-col>
        </a-row>
    </page-body>
    <page-footer>
      <div slot="right">
        <a-button class="ml-3 mr-3" type="primary" :loading="loading" @click="doOk()">{{ $t('dialog.ok') }}</a-button>
        <a-button @click="cancel">{{ $t('dialog.cancel') }}</a-button>
      </div>
    </page-footer>
  </div>
</template>

<script>
import _ from 'lodash'
import * as R from 'ramda'
import { mapGetters, mapState } from 'vuex'
import WindowsMixin from '@/mixins/windows'
import { BRAND_MAP } from '@/constants'
import { currencyUnitMap } from '@/constants/currency'
import { uuid } from '@/utils/utils'
import { CLOUD_ENVS, PLATFORMS, ACCOUNTS, CLOUDPROVIDERS, SUBACCOUNTS } from '@Bill/constants'
import NameRepeated from '@/sections/NameRepeated/index'

const cloudParamMap = {
  onpremise: 'onpremise',
  private: 'false',
  public: 'true',
}

export default {
  name: 'CostconversionCreate',
  components: {
    NameRepeated,
  },
  mixins: [WindowsMixin],
  data () {
    return {
      loading: false,
      productLoading: false,
      regionLoading: false,
      isResrouceListShow: false,
      options: {
        cloud_envs: CLOUD_ENVS,
        platform_brands: PLATFORMS,
        accounts: ACCOUNTS,
        cloudproviders: CLOUDPROVIDERS,
        owners: SUBACCOUNTS,
      },
      form: {
        domain: '',
        cloud_env: 'all',
        platform_brand: 'all',
        account_id: { key: 'all' },
        owner_id: { key: 'all' },
        cloudprovider_id: { key: 'all' },
        policy_type: 'global',
        currency_applied: 'all',
        ratio: 1,
        policy_list: [{ product_code: 'others', rate: 1 }],
        enable_date: this.$moment(),
        // enable_date_end: this.$moment(),
      },
      productOpts: [],
      objectOpts: [{ id: 'whole_order', name: this.$t('bill.whole_order') }],
      regionOpts: [],
      durationOpts: [
        { id: 'unlimited', name: this.$t('bill.unlimited_duration') },
        { id: '1_month', name: this.$t('bill.some_month', [1]) },
        { id: '2_month', name: this.$t('bill.some_month', [2]) },
        { id: '3_month', name: this.$t('bill.some_month', [3]) },
        { id: '4_month', name: this.$t('bill.some_month', [4]) },
        { id: '5_month', name: this.$t('bill.some_month', [5]) },
        { id: '6_month', name: this.$t('bill.some_month', [6]) },
        { id: '7_month', name: this.$t('bill.some_month', [7]) },
        { id: '8_month', name: this.$t('bill.some_month', [8]) },
        { id: '9_month', name: this.$t('bill.some_month', [9]) },
        { id: '10_month', name: this.$t('bill.some_month', [10]) },
        { id: '11_month', name: this.$t('bill.some_month', [11]) },
        { id: '1_year', name: this.$t('bill.some_year', [1]) },
        { id: '2_year', name: this.$t('bill.some_year', [2]) },
        { id: '3_year', name: this.$t('bill.some_year', [3]) },
      ],
      costConversionList: [],
      rules: {
        name: [
          { required: true, message: `${this.$t('common.placeholder')}${this.$t('common.name')}` },
          { validator: this.$validate('resourceName') },
        ],
        enable_date: { type: 'object', required: true, message: this.$t('common.tips.select', [this.$t('bill.text_40')]), trigger: 'change' },
        // enable_date_end: { type: 'object', required: true, message: this.$t('common.tips.select', [this.$t('bill.text_41')]), trigger: 'change' },
        platform_brand: {
          message: this.$t('bill.cost_conversion_scope_tip'),
          validator: () => {
            return this.form.platform_brand !== 'all'
          },
          trigger: 'change',
        },
        policy_list: {
          message: this.$t('bill.policy_list_tip'),
          validator: () => {
            return this.form.policy_list.length > 0
          },
        },
        policy_product: { required: true, message: this.$t('common.tips.select', [this.$t('bill.product_name')]) },
        policy_rate: { required: true, message: this.$t('common.tips.input', [this.$t('bill.resource_ratio')]) },
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      selectedPlatformBrand: '',
      pager: {
        limit: 10,
        current: 1,
        pageSize: 10,
      },
    }
  },
  computed: {
    ...mapGetters(['scope', 'isAdminMode']),
    ...mapState('common', {
      currency: state => state.bill.currency,
      currencyOpts: state => state.bill.currencyOpts,
      exchangeRateAvailable: state => state.bill.exchangeRateAvailable,
    }),
    currencyAppliedOpts () {
      return [{ item_id: 'all', item_name: this.$t('bill.text_259') }, ...this.currencyOpts.map(val => {
        const localItem = currencyUnitMap[val.item_id]
        const text = localItem ? localItem.label : val.item_name
        const currencyItem = { ...val }
        if (val.item_id.indexOf('*_') !== -1) {
          currencyItem.item_name = this.$t('bill.show_origin_2', [val.item_name.replace('*_', '')])
        } else if (val.item_id.indexOf('_') !== -1) {
          currencyItem.item_name = this.$t('bill.text_287', [val.item_name.replace('_', '')])
        } else if (val.item_id.indexOf('*') !== -1) {
          currencyItem.item_name = this.$t('bill.show_origin_1', [val.item_name.replace('*', '')])
        } else {
          currencyItem.item_name = this.$t('bill.text_39', [text])
        }
        return currencyItem
      })]
    },
    isKvm () {
      return this.selectedPlatformBrand === 'OneCloud'
    },
    isAliyun () {
      return this.selectedPlatformBrand === 'Aliyun'
    },
    regionParams () {
      const ret = {
        scope: this.$store.getters.scope,
        cloud_env: 'public',
        brand: 'Aliyun',
        parent_id: 'Aliyun',
      }
      return ret
    },
    productParams () {
      const ret = {
        scope: this.$store.getters.scope,
        cloud_env: 'public',
        query_type: 'product_detail',
        brand: 'Aliyun',
      }
      if (this.form.account_id.key && this.form.account_id.key !== 'all') {
        ret.filter = `account_id.equals(${this.form.account_id.key})`
      }
      return ret
    },
    transProductOpts () {
      const policys = this.form.policy_list.filter(item => item.product_code !== 'others')
      return this.productOpts.map(item => {
        const ret = R.clone(item)
        if (ret.id === 'others') {
          if (policys.length) {
            ret.name = this.$t('common.text00053')
          } else {
            ret.name = this.$t('bill.all')
          }
        } else {
          ret.name = `${item.name}（${item.id}）`
        }
        return ret
      })
    },
    isAddBtnShow () {
      return !this.form.policy_list.length || Math.ceil(this.form.policy_list.length / this.pager.pageSize) === this.pager.current
    },
  },
  created () {
    this.conditionM = new this.$Manager('bill_conditions', 'v1')
    this.regionM = new this.$Manager('cloudregions', 'v1')
    this._conditionList('platform_brand', PLATFORMS, { })
  },
  methods: {
    handleUseHasPolicyCancel () {
      this.changeResourceShow(false)
      this.form.policy_id = ''
    },
    changeResourceShow (bool) {
      this.isResrouceListShow = bool
    },
    selectLabelFormat (item) {
      return [<span><span class="text-color-secondary option-prefix">{ this.$t('bill.ri_lookback_days') }: </span><span> item.value</span></span>]
    },
    addPolicy () {
      this.form.policy_list.splice(this.form.policy_list.length - 1, 0, { rate: 1, object: 'whole_order' })
    },
    deletePolicy (policy, index) {
      this.form.policy_list = this.form.policy_list.filter((item, idx) => {
        return idx !== index
      })
    },
    disabledProducts (index) {
      const ret = ['others']
      return ret
    },
    disabledRegions (regions) {
      if (!R.is(Array, regions)) return []
      if (regions.length === 0) {
        return []
      } else if (regions.includes('unlimited')) {
        return this.regionOpts.filter(item => item.id !== 'unlimited').map(item => item.id)
      } else {
        return ['unlimited']
      }
    },
    productChange (val, index) {
      if (val === 'others') {
        this.form.policy_list = this.form.policy_list.map((item, idx) => {
          if (idx === index) {
            delete item.duration
            delete item.object
            delete item.regions
          }
          return item
        })
      }
    },
    costConversionListChange (list) {
      this.costConversionList = list
    },
    costConversionChange (val) {
      const filterList = this.costConversionList.filter(item => item.id === val)
      if (filterList[0] && filterList[0].user_rules) {
        this.form.policy_list = filterList[0].user_rules.map(item => {
          const regionList = (R.is(String, item.regions) ? JSON.parse(item.regions) : item.regions || []).map(item => item.region_id)
          if (!regionList.length) {
            regionList.push('unlimited')
          }
          return {
            product_code: item.other ? 'others' : item.product_code,
            rate: item.rate,
            regions: regionList,
            object: 'whole_order',
            duration: item.duration ? item.duration : 'unlimited',
          }
        })
      }
    },
    async getRegionList () {
      try {
        this.regionLoading = true
        const res = await this.regionM.list({ params: this.regionParams })
        this.regionOpts = [{ id: 'unlimited', name: this.$t('bill.unlimited') }, ...(res.data.data || [])]
        this.regionLoading = false
      } catch (err) {
        this.regionLoading = false
        throw err
      }
    },
    async getProductList () {
      try {
        this.productLoading = true
        const res = await this.conditionM.list({
          params: this.productParams,
        })
        const list = ((res.data && res.data.data) || []).filter(item => {
          return item.item_id && item.item_name
        }).map(item => {
          return {
            id: item.item_id,
            name: item.item_name,
          }
        })
        const productOpts = [{ id: 'others', name: this.$t('common.text00053') }, ...(list || [])]
        this.productOpts = productOpts
        this.form.policy_list = this.form.policy_list.map(item => {
          const ret = {
            ...item,
          }
          if (productOpts.filter(i => i.id === item.product_code).length === 0) {
            ret.product_code = ''
          }
          return ret
        })
        this.productLoading = false
      } catch (err) {
        this.productLoading = false
        throw err
      }
    },
    cancel () {
      this.$router.push('/cost-conversion')
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$refs.policyForm.validate((valid, err) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(err)
          }
        })
      })
    },
    validatePolicy () {
      const list = []
      this.form.policy_list.map((item, index) => {
        if (!(item.product_code === 'others' || (item.product_code && item.duration && item.regions.length && (item.rate === 0 || item.rate > 0)))) {
          list.push(index + 1)
        }
      })
      return list
    },
    doCreate (data) {
      return new this.$Manager('cost_conversions', 'v1').create({ data: data })
    },
    async doOk () {
      try {
        const checked = await this.validateForm()
        if (!checked) return
        const errorList = this.validatePolicy()
        if (errorList.length) {
          this.createDialog('CostconversionPolicyErrorDialog', {
            errorList,
          })
          return
        }
        this.loading = true
        const {
          domain,
          enable_date,
          // enable_date_end,
          platform_brand,
          cloud_env,
          account_id,
          owner_id,
          cloudprovider_id,
          currency_applied = 'all',
          policy_type,
          ratio,
          policy_list,
          name,
        } = this.form
        const is_public_cloud = cloudParamMap[cloud_env]
        const params = {
          name,
          is_public_cloud,
          domain_id_filter: domain,
          cloud_env: cloud_env === 'all' ? '' : cloud_env,
          brand: platform_brand === 'all' ? '' : platform_brand,
          currency_applied: currency_applied === 'all' ? '' : currency_applied.replace('_', '').replace('*', ''),
          cloudaccount_id: account_id?.key === 'all' ? '' : account_id?.key,
          cloudprovider_id: cloudprovider_id?.key === 'all' ? '' : cloudprovider_id?.key,
          enable_date: enable_date.format('YYYYMM'),
          // enable_date_end: enable_date_end.format('YYYYMM'),
          ratio: policy_type === 'global' ? ratio : 1,
          type: policy_type,
          owner_id: owner_id?.key === 'all' ? '' : owner_id?.key,
        }
        if (policy_type === 'global') {
          params.ratio = ratio
        } else {
          params.user_rules = policy_list.map(item => {
            const resItem = {
              product_code: item.product_code,
              product_name: this.filterTargetName('product', item.product_code),
              object: 'whole_order',
              rate: item.rate,
              duration: item.duration === 'unlimited' ? '' : item.duration,
              regions: (item.regions || []).filter(key => key !== 'unlimited').map(key => {
                return {
                  region_id: key,
                  region: this.filterTargetName('region', key),
                }
              }),
            }
            if (item.product_code === 'others') {
              delete resItem.product_code
              delete resItem.product_name
              resItem.other = true
            }
            return resItem
          })
        }
        if (params.owner_id) {
          const target = this.options.owners.filter(item => item.item_id === params.owner_id)
          if (target[0]) {
            params.owner = target[0].item_name
          }
        }
        await this.doCreate(params)
        this.$router.push('/cost-conversion')
        this.loading = false
      } catch (error) {
        this.loading = false
        throw error
      }
    },
    disabledDate (date) {
      const current = date.endOf('day')
      return current && current < this.$moment().endOf('day')
    },
    _conditionList (queryType, cons = [], reqQuery = {}) {
      const adminParams = { admin: this.isAdminMode, scope: this.scope, $t: uuid() }
      const query = Object.assign({ query_type: queryType, cloudaccount_exist: true }, reqQuery, adminParams)
      // 先清空
      this.options[`${queryType}s`] = [...cons]
      this.conditionM.list({ params: query }).then(({ data: { data } }) => {
        if (queryType === 'platform_brand') {
          data = data.map(v => {
            return { ...v, item_name: (_.get(BRAND_MAP, `[${v.item_name}].label`) || v.item_name) }
          })
        }
        this.options[`${queryType}s`] = [...cons, ...data]
      })
    },
    uniqueArr (arr, byId = 'item_id') {
      const obj = {}
      arr.forEach(val => {
        obj[val[byId]] = val
      })
      return Object.values(obj)
    },
    filterTargetName (type, id) {
      let list = []
      if (type === 'product') {
        list = this.productOpts
      } else if (type === 'region') {
        list = this.regionOpts
      }
      const ret = list.filter(item => item.id === id)
      return ret.length ? ret[0].name : id
    },
    change (type, value) {
      const id = R.type(value) === 'Object' ? value.key : value
      if (type === 'cloud_env') {
        this.$nextTick(() => {
          this.form.platform_brand = 'all'
          this.form.account_id = { key: 'all' }
          this.form.cloudprovider_id = { key: 'all' }
        })
        const query = { cloud_env: value }
        if (id !== 'public') {
          this.form.policy_type = 'global'
        }
        this._conditionList('platform_brand', PLATFORMS, query)
        this._conditionList('account', ACCOUNTS, query)
        this._conditionList('cloudprovider', CLOUDPROVIDERS, query)
        this.selectedPlatformBrand = ''
      }
      if (type === 'platform_brand') {
        this.$nextTick(() => {
          this.form.account_id = { key: 'all' }
          this.form.cloudprovider_id = { key: 'all' }
          this.form.owner_id = { key: 'all' }
        })
        const query = { brand: id }
        this._conditionList('account', ACCOUNTS, query)
        this.selectedPlatformBrand = id
        if (id === 'Aliyun') {
          this.getRegionList()
          this.getProductList()
          this._conditionList('owner', SUBACCOUNTS, query)
        } else {
          this.form.policy_type = 'global'
          this._conditionList('cloudprovider', CLOUDPROVIDERS, query)
        }
        if (id && id !== 'all') {
          this.$refs.policyForm.clearValidate('platform_brand')
        }
      }
      if (type === 'account_id') {
        this.$nextTick(() => {
          this.form.cloudprovider_id = { key: 'all' }
        })
        const query = { filter: `account_id.equals("${id}")` }
        if (this.form.platform_brand === 'Aliyun') {
          this._conditionList('owner', SUBACCOUNTS, query)
          this.getProductList()
        } else {
          this._conditionList('cloudprovider', CLOUDPROVIDERS, query)
        }
      }
    },
    handleImportClick () {
      this.createDialog('CostconversionImportResourcePolicyDialog', {
        ok: (data) => {
          const policy_list = []
          data.map(item => {
            const row = { product_code: '', regions: [], rate: null, duration: '' }
            // 产品明细
            row.product_code = item['产品明细Code']
            row.product_name = item['产品明细']
            // 折扣系数
            row.rate = item['折扣']
            // 地域
            const targetRegions = []
            const originRegions = item['地域'].split('，')
            originRegions.map(region => {
              const transRegion = region === '不限' ? 'unlimited' : region
              const targetRegion = this.regionOpts.filter(r => r.id === transRegion || r.name === transRegion)
              if (targetRegion[0]) {
                targetRegions.push(transRegion)
              }
            })
            if (targetRegions.length === originRegions.length) {
              row.regions = targetRegions
            }
            // 定购时长
            let transDuration = (item['订购时长'] || '').replace('月', '_month').replace('年', '_year')
            if (transDuration === '不限') {
              transDuration = 'unlimited'
            }
            const targetDuration = this.durationOpts.filter(d => d.id === transDuration)
            if (targetDuration[0]) {
              row.duration = transDuration
            }
            policy_list.push(row)
          })
          policy_list.push({ product_code: 'others', rate: 1 })
          this.form.policy_list = policy_list
          // 文件中产品名称补充到现有参数
          const productOpts = []
          policy_list.map(item => {
            if (item.product_code && item.product_name) {
              const targetList = this.productOpts.filter(product => product.id === item.product_code)
              if (!targetList.length) {
                productOpts.push({
                  id: item.product_code,
                  name: item.product_name,
                })
              }
            }
          })
          this.productOpts = [...this.productOpts, ...productOpts]
        },
      })
    },
    isProductShow (index) {
      const { current, pageSize } = this.pager
      return index >= (current - 1) * pageSize && index < current * pageSize
    },
    pageChange (val) {
      this.pager.current = val
    },
    sizeChange (current, pageSize) {
      this.pager.pageSize = pageSize
      if (this.form.policy_list.length < pageSize * (this.pager.current - 1)) {
        this.pager.current = 1
      }
    },
  },
}
</script>

<style lang="less" scoped>
.product-order {
  margin-right: 10px;
  height: 30px;
  line-height: 40px;
  opacity: 0.75;
}
</style>
